import { CertificationItem as CertificationItemDto } from "src/app/proxy/certifications/models";

export class CertificationItem {
  localId: string;
  id: number;
  activityReportId: string;
  activityId: number;
  quantity: number;
  total: number;
  deleted: boolean;
  updated: string;
  version: number;
  operation: string;
  calculatedFlag: boolean;

  constructor(dto: CertificationItemDto | CertificationItem) {
    Object.assign(this, dto);

    this.localId = ('localId' in dto ? dto.localId : undefined) ?? crypto.randomUUID();
  }
}
